import React from 'react';
import styles from '../../../stylesheets/management_site/tenantForm.module.scss';

const TenantFormAutocomplete = ({
  searchResults,
  isSearching,
  showAutocomplete,
  onSelectTenant,
  onClose,
}) => {
  const handleSelectTenant = (tenant) => {
    if (tenant.roles && tenant.roles.length > 0) {
      const role = tenant.roles[0].toLowerCase();
      const isVowel = ['a', 'e', 'i', 'o', 'u'].includes(role[0]);
      const article = isVowel ? 'an' : 'a';
      const roleCapitalized = role.charAt(0).toUpperCase() + role.slice(1);

      window.confirm(
        `Are you sure you want to use this ${tenant.roles[0]} as ${article} ${roleCapitalized}?`,
        (confirmed) => {
          if (confirmed) {
            onSelectTenant(tenant);
          }
        }
      );
    } else {
      onSelectTenant(tenant);
    }
  };

  if (!showAutocomplete) return null;

  return (
    <div
      className={`autocomplete-dropdown ui-menu ${styles.autocompleteDropdown}`}
    >
      {isSearching ? (
        <div className={styles.autocompleteSearching}>Searching...</div>
      ) : searchResults.length > 0 ? (
        searchResults.map((tenant, index) => (
          <div
            key={tenant.id || index}
            className={`autocomplete-item ui-menu-item ${styles.autocompleteItem}`}
            onClick={() => handleSelectTenant(tenant)}
          >
            <div className={styles.autocompleteItemName}>
              {tenant.firstname} {tenant.lastname}
            </div>
            {tenant.email && (
              <div className={styles.autocompleteItemEmail}>{tenant.email}</div>
            )}
            {tenant.roles && tenant.roles.length > 0 && (
              <div className={styles.autocompleteItemRole}>
                Role: {tenant.roles[0]}
              </div>
            )}
          </div>
        ))
      ) : (
        <div className={styles.autocompleteNoResults}>No tenants found</div>
      )}
    </div>
  );
};

export default TenantFormAutocomplete;
